import { configureStore } from '@reduxjs/toolkit';
import blogReducer from "../features/Blog/BlogSlice";
import blogsReducer from "../features/Blogs/BlogsSlice";
import filteredBlogReducer from "../features/Filtered/FilteredSlice";
import relatedBlogsReducer from "../features/RelatedBlogs/RelatedBlogsSlice";
import updateBlogReducer from "../features/UpdateBlog/UpdateBlogSlice";

export const store = configureStore({
  reducer: {
    blogs: blogsReducer,
    blog: blogReducer,
    updateBlog: updateBlogReducer,
    relatedBlogs: relatedBlogsReducer,
    filtered: filteredBlogReducer
  }
});
